import { ErrorMessage, Field, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { CardBody, Col, FormGroup, Label, Row } from 'reactstrap';
import { customReactSelectStyles } from '../../../../styles/ReactSelectStyles';
import UserListData from "../../../../utils/UserListData.json";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import UploadFile from '../../../organization/create-organization/UploadFile';

export const formatOptionLabelWithFlag = ({ label, flag }: FlagOptionType) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {flag && (
      <img
        src={`/assets/fonts/flag-icon/${flag}.svg`}
        alt={label}
        style={{ width: 20, height: 15, marginRight: 8 }}
      />
    )}
    <span>{label}</span>
  </div>
);
// Define a type for option objects, especially for those with flags
type FlagOptionType = {
  value: string;
  label: string;
  flag?: string;
};

function UserListInfoSection({ data }: any) {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<any>();

  // Custom component to render options with flags


  return (
    <>
      <div className="mb-4">
        <CardBody>
          <Row>
            <Col sm="4">
              <FormGroup>
                <Label>{t("FirstName")} <span className="txt-danger">*</span></Label>
                <Field
                  name="firstName"
                  type="text"
                  className="form-control"
                  placeholder={t("FirstNamePlaceholder")}
                />
                <ErrorMessage
                  name="firstName"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label> {t("LastName")} <span className="txt-danger">*</span></Label>
                <Field
                  name="lastName"
                  type="text"
                  className="form-control"
                  placeholder={t("LastNamePlaceholder")}
                />
                <ErrorMessage
                  name="lastName"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>{t("OrganizationMobile")} <span className="txt-danger">*</span></Label>
                <div style={{ display: 'flex', gap: '12px' }}>
                  <Select
                    name="countryCode"
                    options={UserListData?.countrycode}
                    placeholder="+91"
                    className="basic-single-select"
                    classNamePrefix="select"
                    isSearchable={true}
                    styles={{
                      ...customReactSelectStyles,
                      container: (provided) => ({ ...provided, width: '200px' }),
                    }}
                    value={UserListData?.countrycode.find((option: any) => option.value === values.countryCode) || null}
                    onChange={(option: any) => setFieldValue('countryCode', option ? option.value : '')}
                    formatOptionLabel={formatOptionLabelWithFlag}
                    
                  />
                  <Field
                    name="mobileNumber"
                    type="tel"
                    className="form-control"
                    placeholder={t("OrganizationMobilePlaceholder")}
                  />
                </div>
                <ErrorMessage
                  name="countryCode"
                  component="span"
                  className="text-danger"
                />
                <ErrorMessage
                  name="mobileNumber"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>{t("Email")} <span className="txt-danger">*</span></Label>
                <Field
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder={t("OrganizationEmailPlaceholder")}
                />
                <ErrorMessage
                  name="email"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>{t("Gender")} <span className="txt-danger">*</span></Label>
                <Select
                   placeholder={t("selectGender")}
                   className="basic-single-select"
                   classNamePrefix="select"
                   isSearchable={true}
                   isClearable
                  options={UserListData?.gender}
                
                  // styles={customReactSelectStyles}
                  value={UserListData?.gender.find((opt: any) => opt.value === values.gender) || null}
                  onChange={(option: any) => setFieldValue('gender', option ? option.value : '')}
                 
                
            
                />
                <ErrorMessage
                  name="gender"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
              
            <Col sm="4">
              <FormGroup className="d-flex flex-column align-items-stretch">
                <Label check>{t("BirthDate")} <span className="txt-danger">*</span></Label>
                <ReactDatePicker
                  className="datepicker-here form-control"
                  selected={values.birthDate ? new Date(values.birthDate) : null}
                  onChange={(date) => setFieldValue('birthDate', date)}
                  dateFormat="dd/MM/yyyy"
                  name="birthDate"
                />
                <ErrorMessage
                  name="birthDate"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>{t("Language")} <span className="txt-danger">*</span></Label>
                <Select
                  id="languages-select"
                  options={UserListData.languages}
                  placeholder={t("LanguagePlaceholder")}
                  isMulti
                  value={UserListData.languages.filter((opt: any) => values.languages?.includes(opt.value))}
                  onChange={(selectedOptions: any) => {
                    setFieldValue('languages', selectedOptions ? selectedOptions.map((opt: any) => opt.value) : []);
                  }}
                  styles={customReactSelectStyles}
                  classNamePrefix="select"
                  isClearable
                />
                <ErrorMessage
                  name="languages"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <FormGroup>
                <Label>{t("OrganizationName")}<span className="txt-danger">*</span></Label>
                <Field
                  name="organizationname"
                  type="text"
                  className="form-control"
                  placeholder={t("OrganizationNamePlaceholder")}
                />
                <ErrorMessage
                  name="organizationname"
                  component="span"
                  className="text-danger"
                />
              </FormGroup>
            </Col>
            <Col sm="4">
              <UploadFile label={t("UserImage")} data={data?.userImage} />
            </Col>
          </Row>
        </CardBody>
      </div>
    </>
  );
}

export default UserListInfoSection;